import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginPageComponent } from './onelog/views/login/login-page/login-page.component';
import { AuthguardGuard } from './onelog/common/auth/authguard.guard';
import { ListReportComponent } from './onelog/views/reports/list-report/list-report.component';
import { AuthFromSachComponent } from './onelog/common/auth-from-sach/auth-from-sach.component';

import { ReportsRoutingModule } from './onelog/views/reports/reports.routing.module';

const routes: Routes = [
  { path: 'login', component: LoginPageComponent },
  {
    path: 'list-reports',
    component: ListReportComponent,
    canActivate: [AuthguardGuard],
  },
  {
    path: 'onelog-auth-controller/:token/:user/:redirectTo',
    component: AuthFromSachComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
